/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { ExperienceTrackerProvider } from '@jira/platform__jira-experience-tracker/src/ui/experience-tracker-provider/ExperienceTrackerProvider.tsx';
import { routeAnalyticsAttributes } from '@jira/platform__utils-route-analytics/src/main.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { SubProductForAnalyticsUpdater } from './subproduct-updater/index.tsx';
import type { MetricsContainersProps } from './types.tsx';

export const MetricsContainers = ({ children }: MetricsContainersProps): React.JSX.Element => (
	<ContextualAnalyticsData attributes={routeAnalyticsAttributes}>
		<ExperienceTrackerProvider>
			{!__SERVER__ && (
				<JSErrorBoundary
					fallback="unmount"
					id="metrics-containers-subproduct-updater"
					packageName="page-container"
				>
					<SubProductForAnalyticsUpdater />
				</JSErrorBoundary>
			)}
			{children}
		</ExperienceTrackerProvider>
	</ContextualAnalyticsData>
);
